import { render, staticRenderFns } from "./previewChapterContent.vue?vue&type=template&id=770b1fd4&scoped=true"
import script from "./previewChapterContent.vue?vue&type=script&lang=js"
export * from "./previewChapterContent.vue?vue&type=script&lang=js"
import style0 from "./previewChapterContent.vue?vue&type=style&index=0&id=770b1fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770b1fd4",
  null
  
)

export default component.exports